import { DecorationNode, FNode, FNodeTypesEnum, FurnitureNode } from '../types/index.js';

/**
 * Gets the shallow parent selector on which the node is stacked
 *
 * For children nodes of a composition, the originator's shallow parent will be used
 */
export const getStackingParentSelector = (node: FNode) => {
  return (
    (node as FurnitureNode | DecorationNode).shallowParent ??
    (node.type === FNodeTypesEnum.Furniture ? node.originator?.shallowParent : null)
  );
};
